import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LoginResponse } from 'src/app/auth/models';
import { API_URL } from '../constants/api-url.constants';
import { LocalStorageService, StorageItem } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class RefreshTokenService {
  private refreshTokenTimeout!: NodeJS.Timeout;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly localStorageService: LocalStorageService
  ) {}

  startRefreshTokenTimer(access_token: string) {
    // parse json object from base64 encoded jwt token
    const jwtToken = JSON.parse(atob(access_token.split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - 60 * 1000;
    this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }

  refreshToken(): Observable<LoginResponse | undefined> {
    return this.httpClient.post<LoginResponse>(API_URL.account.refreshAccessToken, {}).pipe(
      map((response) => {
        this.storeAuthTokens(response);
        this.startRefreshTokenTimer(response.access_token);
        return response;
      })
    );
  }

  storeAuthTokens(loginResponse: LoginResponse) {
    this.localStorageService.setItem(StorageItem.AuthToken, loginResponse.access_token);
    this.localStorageService.setItem(StorageItem.RefreshToken, loginResponse.refresh_token);
  }
}
